import forge from 'apis/forge';
import Icon, { IconType } from 'components/Icon';
import { Frame, SiteFrameEntry } from 'dragonmouse-shared/interfaces';
import { displayViewOnlyModal } from 'redux/mode/util';
import * as S from './styles';

interface SiteEntryProps {
	entry: SiteFrameEntry;
	frame: Frame;
	frameId: string;
}

const SiteEntry = ({ entry, frame, frameId }: SiteEntryProps) => {
	// SiteEntry is active if siteId matches and visualEditActive is false (or not set)
	const isActive = frame.siteId === entry.siteId && !frame.metadata.visualEditActive;

	const onClick = () => {
		if (!frame) return;

		if (frame.viewOnly) {
			displayViewOnlyModal();
			return;
		}

		// no reason to await here, so not gonna await
		forge.updateFrame(
			{
				update: {
					id: frameId,
					siteId: entry.siteId,
					metadata: {
						...frame.metadata,
						visualEditActive: false, // Clear any active visual edit
					},
				},
			},
			true
		);
	};

	return (
		<S.Base key={entry.id} active={isActive} onClick={onClick} disabled={false}>
			<S.LabelHeader>
				<S.Label>{entry.label}</S.Label>
				<S.Spacer />
				<S.Icon>
					<Icon
						type={isActive ? IconType.CHECK : IconType.LINE_ARROW_RIGHT}
						width={16}
						height={16}
					/>
				</S.Icon>
			</S.LabelHeader>
			<S.LabelDetails>
				<S.SubLabel>{entry.subLabel}</S.SubLabel>
			</S.LabelDetails>
		</S.Base>
	);
};

export default SiteEntry;
